export default __webpack_public_path__ + "static/media/whiteBackground_forum.c7259207.svg";